export default {
    component: () => import(/* webpackChunkName: "landing-layout" */ '@/modules/landing/layouts/LandingLayout.vue'),
    children: [
        {
            path: '',
            name: 'home',
            component: () => import(/* webpackChunkName: "home-view" */ '@/modules/landing/views/HomeView.vue'),
        }
    ]
}